export default "__VITE_ASSET__C$B1B3$M__"